<template>
  <Popover ref="applyAllPopover" :showHeader="true" :headerTitle="headerTitle">
    <div class="order-item-apply-all-popover-content">
      <slot />

      <div v-show="!disabled">
        <div class="pb-1 border-bottom">
          <div class="row">
            <div class="col-4 font-weight-bold">Apply To</div>
            <div class="col-8">
              <span class="float-right">
                <FormButton class="btn-default btn-xxs" @click="selectAll">Select All</FormButton>
                <FormButton class="btn-default btn-xxs ml-1" @click="clearAll">Clear</FormButton>
              </span>
            </div>
          </div>
        </div>

        <div class="mt-2"> </div>

        <div class="target-list-area">
          <template v-for="targetItem in targetItemList">
            <div class="row" :key="targetItem.id">
              <div class="col-10 col-form-label" v-html="targetItem.name"></div>
              <div class="col-2 pl-0"><FormCheckbox v-model="targetItem.value" /></div>
            </div>
          </template>
          <p v-if="targetItemList.length == 0" class="text-muted text-center">No available items to apply to</p>

          <div class="mt-2"> </div>
          <FormButton class="btn-primary btn-xxs" @click="applySettings" :disabled="selectedItemList.length == 0">Apply</FormButton>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.order-item-apply-all-popover-content {
  padding: 10px;
  min-width: 275px;
  font-size: 12px;
}
.target-list-area {
  font-size: 0.7rem;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'OrderItemApplyAllPopover',
  components: {
    Popover
  },
  props: {
    headerTitle: String,
    itemList: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      targetItemList: this.generateItemList()      
    }
  },
  computed: {
    selectedItemList() {
      return this.targetItemList.filter(item => item.value)
    }
  },
  watch: {
    itemList: function() {
      this.targetItemList = this.generateItemList()
    }
  },
  methods: {
    displayFromElement(element) {
      this.clearAll()
      this.$refs.applyAllPopover.displayFromElement(element)
    },
    selectAll() {
      this.targetItemList.forEach(item => {
        item.value = true
      })
    },
    clearAll() {
      this.targetItemList.forEach(item => {
        item.value = false
      })
    },
    applySettings() {
      this.$refs.applyAllPopover.hidePopover()
      this.$emit('applySettings', this.targetItemList.filter(item => item.value))
    },

    generateItemList() {
      return this.itemList
      .map(listItem => {
        return {
          id: listItem.id,
          name: listItem.name,
          value: false
        }
      })
    }
    
  }
}
</script>